// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"05537d95","707":"24b639ca","736":"e62f6e43"}[chunkId] + ".chunk.js";
};